
<!--     <ng-template #elseBlock class="spinner">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </ng-template> -->

    <div *ngIf="!pdf ; else elseBlock" class="spinner">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>

    <ng-template #elseBlock>
    <div *ngIf="message" class="divPDF"
        style="display: flex; justify-content: center; align-items: center; text-align: center;">
        <h3> {{message}}</h3>
    </div>

    <div style="display: flex;flex-direction: column;justify-content: space-between;height: 100%;">
        <div style="display: flex;justify-content: center;">
            <iframe [attr.src]="pdf" width="700" height="450">
            </iframe>
        </div>
        <div style="display: flex;justify-content: center">
            <button mat-raised-button class="buttonPrimary"  (click)="close()">Cerrar</button>
        </div>
    </div>
    </ng-template>



